import { AccessRightModel } from '../permissions';
import { DataEntryPresenterModel } from './data-entry-presenter.model';

export class PermissionsPresenterModel extends DataEntryPresenterModel {
  permission: Array<AccessRightModel>;
  parentPermission: Array<AccessRightModel>;
}
